<!--分页-->
<template>
  <div class="page">
    <el-pagination
      :total="total"
      :page-size="size"
      :current-page="page"
      :pager-count="5"
      background
      layout="prev, pager, next"
      @current-change="changePage"
    />
  </div>
</template>
<script>
import { PAGE_SIZE } from '@/assets/js/enterprise/index.js'
export default {
  props: {
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentPage: 1,
      size: PAGE_SIZE
    }
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page)
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/css/enterprise_color.scss";
.page {
  >>> .el-pagination.is-background {
    padding-top: 0px;
  }
  >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: $blue;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/model/page.vue